import moment from "moment";

export class RentsToPayAPIFilters {
  bankAccountId: number = -1;
  daysOverdue: number = 0;
  onlyIncludeCurrentTenancies: boolean = false;
  landlordId: number = -1;
  dueDate: string = moment().toISOString();
}
